import React, { useMemo, useEffect } from "react";

import { initialState } from "./useAppReducer";
import { ActionType, StateType, actionTypes } from "../types/state";

export function useAppStore([state, dispatch]: [StateType, React.Dispatch<ActionType>]) {
  const keyLocal = "appInfo";
  useEffect(() => {
    const local = localStorage.getItem(keyLocal);
    const localJSON = local ? JSON.parse(local) : null;
    if (localJSON) {
      dispatch({
        type: actionTypes.setAllState,
        value: localJSON,
      });
    } else {
      localStorage.setItem(keyLocal, JSON.stringify(state));
      dispatch({
        type: actionTypes.setAllState,
        value: state,
      });
    }
  }, []);

  useEffect(() => {
    if (state !== initialState) {
      localStorage.setItem(keyLocal, JSON.stringify(state));
    }
  }, [state]);

  const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);
  return contextValue;
}
